import { useContext } from "react";
import { GlobalSearchContext } from "./GlobalSearchContextInstance";

export const useGlobalSearch = () => useContext(GlobalSearchContext);
